import { IBaseResource } from "../api.types";
import { IOrganizationMinimal } from "../organizations";
import { IScopeClause } from "../scopes";
import { IUser } from "../users";

export enum FeedbackType {
    INCORRECT_CLAUSE_TYPE = "Incorrect Clause Type",
    POOR_LANGUAGE_MATCH = "Poor Language Match",
    CLAUSE_NOT_PRESENT = "Clause not Present in Document",
    OTHER = "Other...",
}

export enum Vote {
    UP = 1,
    DOWN = 0,
}

export interface IFeedbackBase {
    vote: Vote;
    feedback_type: FeedbackType;
    additional_comments: string;
}

export interface IFeedback extends IFeedbackBase, IBaseResource {
    scope_clause_id: number;
    user_id: number;
    status: FeedbackStatus;
    organization: IOrganizationMinimal;
    user: IUser;
    scope_clause: IScopeClause;
}

export enum FeedbackStatus {
    UNRESOLVED = "Unresolved",
    UNDER_REVIEW = "Under Review",
    RESOLVED = "Resolved",
}

export interface IFeedbackCreate extends IFeedbackBase {}
